import Container from 'react-bootstrap/Container';
import { Row, Col, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import './SideBar.scss';
import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setadm } from '../../Utilidades/session';

export const SideBar = () => {
  let location = useLocation();

  const isRouteActive = (path: string) => location.pathname === path;

  const selectedClass = (path: string) =>
    isRouteActive(path) ? 'selected' : '';

  const imageUrl = useSelector((state: any) => state.authUser.imageUrl);
  const pantallas = useSelector((state: any) => state.authUser.pantallas);

  //Modificacion: Marca de Inicio WII C-24-1229-24
  var contienecomunicado = "0";
  pantallas.forEach((pantalla) => {
    if (pantalla.nombre == "Comunicados") {
      contienecomunicado = "1";
    }
  });
  setadm(contienecomunicado);
  //Modificacion: Marca de Fin WII C-24-1229-24

  const [margen, setMargen] = useState<number>(0);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setMargen(window.pageYOffset);
    });
  }, []);
  return (
    <>
      {pantallas.length > 0 ? (
        <div className="sidebar" style={{ marginTop: margen.toString() + 'px' }}>
          <div className="avatar mt-4">
            <img src={imageUrl} />
          </div>
          <Link to={'/'}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Principal</Tooltip>}
            >
              <Button
                className={'mt-4 ' + selectedClass('/')}
                variant={isRouteActive('/') ? 'red-light' : 'light'}
              >
                <div className="material-icons-outlined">home</div>
              </Button>
            </OverlayTrigger>
          </Link>
          {pantallas.map((pantalla) => {
            const link = '/' + pantalla.link;
            return (
              <Link to={link} key={pantalla.pantalla_id}>
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip>{pantalla.nombre}</Tooltip>}
                >
                  <Button
                    className={'mt-4 ' + selectedClass(link)}
                    variant={isRouteActive(link) ? 'red-light' : 'light'}
                  >
                    <div className="material-icons-outlined">
                      {pantalla.icono}
                    </div>
                  </Button>
                </OverlayTrigger>
              </Link>
            );
          })}
          {/* 
        <Link to={'/solicitud-comunicados'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Solicitud de Comunicados</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/solicitud-comunicados')}
              variant={
                isRouteActive('/solicitud-comunicados') ? 'red-light' : 'light'
              }
            >
              <div className="material-icons-outlined">note_add</div>
            </Button>
          </OverlayTrigger>
        </Link>
        <Link to={'/comunicados'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Comunicados</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/comunicados')}
              variant={isRouteActive('/comunicados') ? 'red-light' : 'light'}
            >
              <div className="material-icons-outlined">article</div>
            </Button>
          </OverlayTrigger>
        </Link>

        <Link to={'/enlaces'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Enlaces</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/enlaces')}
              variant={
                isRouteActive('/enlaces') || isRouteActive('/enlace')
                  ? 'red-light'
                  : 'light'
              }
            >
              <div className="material-icons-outlined">link</div>
            </Button>
          </OverlayTrigger>
        </Link>

        <Link to={'/analiticos'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Estadísticas</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/analiticos')}
              variant={isRouteActive('/analiticos') ? 'red-light' : 'light'}
            >
              <div className="material-icons-outlined">analytics</div>
            </Button>
          </OverlayTrigger>
        </Link>
        <Link to={'/usuarios'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Usuarios</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/usuarios')}
              variant={
                isRouteActive('/usuarios') || isRouteActive('/agregar-usuario')
                  ? 'red-light'
                  : 'light'
              }
            >
              <div className="material-icons-outlined">account_box</div>
            </Button>
          </OverlayTrigger>
        </Link>

        <Link to={'/roles-permisos'}>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Roles y Permisos</Tooltip>}
          >
            <Button
              className={'mt-3 ' + selectedClass('/roles-permisos')}
              variant={
                isRouteActive('/roles-permisos') ||
                isRouteActive('/detalle-rol/:id')
                  ? 'red-light'
                  : 'light'
              }
            >
              <div className="material-icons-outlined">manage_accounts</div>
            </Button>
          </OverlayTrigger>
        </Link> */}
        </div>
      )
        : ""
      }
    </>
  );
};
